
import SortSpecification from "./SortSpecification";

const mNameSort = new WeakMap();
const mEmailSort = new WeakMap();
const mNotesSort = new WeakMap();

const sortSpecKeysTable = Object.freeze({
    name: "name",
    email: "email",
    notes: "notes"
});

const sortSpecKeys = Object.values(sortSpecKeysTable);

const mSortSpecTable = new WeakMap();

class RecipientSortSpecification {
    constructor(enableNameSort, enableEmailSort, enableNotesSort) {

        let enabledFlags = [enableNameSort, enableEmailSort, enableNotesSort].filter((flag) => (flag === true));
        if (enabledFlags.length > 1) {
            throw new TypeError("Cannot Initialize Recipient Sort Specification: More than one sort initially enabled");
        }

        let onSortEnabledFn = (tgt) => { this._onSortEnabled(tgt); };

        let nameSortSpec = new SortSpecification((enableNameSort === true), sortSpecKeysTable.name, onSortEnabledFn);
        mNameSort.set(this, nameSortSpec);

        let emailSortSpec = new SortSpecification((enableEmailSort === true), sortSpecKeysTable.email, onSortEnabledFn);
        mEmailSort.set(this, emailSortSpec);

        let notesSortSpec = new SortSpecification((enableNotesSort === true), sortSpecKeysTable.notes, onSortEnabledFn);
        mNotesSort.set(this, notesSortSpec);

        mSortSpecTable.set(this, new Map([
            [sortSpecKeysTable.name, nameSortSpec],
            [sortSpecKeysTable.email, emailSortSpec],
            [sortSpecKeysTable.notes, notesSortSpec]
        ]));
    }

    get name() {
        return mNameSort.get(this);
    }

    get email() {
        return mEmailSort.get(this);
    }

    get notes() {
        return mNotesSort.get(this);
    }

    get sortEnabled() {
        let sortSpecTable = mSortSpecTable.get(this);
        let combinedSortEnabled = sortSpecKeys.map((sortKey) => {
            let sortEnabledKey = (sortSpecTable.get(sortKey).isEnabled) ? "1" : "0";
            return sortEnabledKey;
        }).join("|");

        return combinedSortEnabled;
    }

    get sortContent() {
        let sortSpecTable = mSortSpecTable.get(this);
        let combinedSortContent = sortSpecKeys.map((sortKey) => {
            let sContent = sortSpecTable.get(sortKey).spec.sortReverse;
            return (sContent != null) ? sContent : "null";
        }).join("|");

        return combinedSortContent;
    }

    _onSortEnabled(enabledTarget) {
        let sortSpecTable = mSortSpecTable.get(this);
        let filteredSortSpecKeys = sortSpecKeys
            .filter((sKey) => (sKey !== enabledTarget));

        filteredSortSpecKeys
            .forEach(
                (sortSpecTarget) => {
                    sortSpecTable.get(sortSpecTarget).isEnabled = false;
                }
            );
    }
}

RecipientSortSpecification.SortKeys = sortSpecKeys;

export default RecipientSortSpecification;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/RecipientSortSpecification.js
// module id = NJry
// module chunks = 1